import React from "react";
import ImagesGallerySelection from "./Shared/ImagesGallerySelection";
import { Box, CircularProgress } from "@mui/material";
import { useBrowseExpertExStock } from "../../../store/Apis/SuitesApps/ImageSuitesApi";

interface ExpertExStockImagesProps{
   setImageSourceSelected: (image: File | string | null) => void;
}

const ExpertExStockImages = ({setImageSourceSelected}:ExpertExStockImagesProps) => {
  const { data: expertExStockImages, isLoading } = useBrowseExpertExStock();
 
  const formattedImagesData = expertExStockImages?.map((image) => ({
    imageUrl: image,
    createdAt: null, // Assuming createdAt is not available, set to null
  })) || [];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <CircularProgress size={50} color="primary" />
        </Box>
      ) : (
        <ImagesGallerySelection imagesData={formattedImagesData} setImageSourceSelected={setImageSourceSelected}/>
      )}
    </Box>
  );
};

export default ExpertExStockImages;
